import React from "react";
import Layout from "../../components/layouts/Layout";

const PageNotFound = () => {
  return (
    <>
      <Layout title={`Go Back Page Not Found`}>
        <h4>PageNotFound</h4>
      </Layout>
    </>
  );
};

export default PageNotFound;
